/**
 * Router-level pending fallback (task 30 fix round 2) — shown while a
 * route's code-split chunk is still downloading (see `autoCodeSplitting` in
 * `vite.config.ts`). Reuses the same centred, muted-text loading treatment
 * already used for auth bootstrapping (`features/auth/auth-gate.tsx`,
 * `routes/index.tsx`) rather than inventing a new spinner.
 */
export function RoutePendingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center text-body text-[var(--fg-muted)]">
      Betöltés…
    </div>
  );
}
